var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandSmallDarkblue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons-navigation/Down-expand-small/Darkblue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.67015398,6.89106667 C6.50748731,6.89106667 6.34482065,6.83173333 6.21748731,6.71306667 L0.213487313,1.1564 C-0.0565126873,0.9064 -0.0725126873,0.4844 0.177487313,0.2144 C0.428153979,-0.0562666667 0.848820646,-0.0729333333 1.11948731,0.177733333 L6.66948731,5.31573333 L12.2034873,0.1784 C12.4728206,-0.0722666667 12.8948206,-0.0569333333 13.146154,0.213733333 C13.396154,0.483733333 13.380154,0.905066667 13.1108206,1.15573333 L7.12348731,6.71306667 C6.99615398,6.83173333 6.83282065,6.89106667 6.67015398,6.89106667",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-navigation/Down-expand-small/Darkblue"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(5.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#003755",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandSmallDarkblue);
export default __webpack_public_path__ + "static/media/expand-small_darkblue.8046a27820c8a0aac7f8a95afd40304e.svg";
export { ForwardRef as ReactComponent };